import script from "./CommentPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentPopover.vue?vue&type=script&setup=true&lang=js"

import "./CommentPopover.vue?vue&type=style&index=0&id=442e0408&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-442e0408"]])

export default __exports__